import React from 'react';
import { Spin } from 'antd';
import './Loading.css';

export default function Loading() {
  return (
    <div className="app-loading">
      <Spin size="large" />
    </div>
  );
}
